/**
 * Bundles
 */

// React
import React, { FunctionComponent, useEffect, useState } from 'react';

// Components
import Pagination from '@material-ui/lab/Pagination';
import List from './list';

// UI
import theme from '../../theme';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import {
  Typography,
  CircularProgress,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  DialogTitle,
  TextField,
  IconButton,
  MenuItem,
  Select,
  FormControl,
  FormLabel, Paper,
} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {
  mdiAccountOutline,
  mdiPackageVariantClosed,
  mdiStateMachine,
  mdiHomeSearchOutline,
  mdiCalendar,
  mdiClose,
  mdiPencilOutline,
  mdiPlus, mdiPackageVariant, mdiKey, mdiFile, mdiPaperclip
} from '@mdi/js';

// Helper
import {
  removeEmptyValueObject,
  translate,
} from '../../utils/helpers';

// Type
import {
  Props,
  Status,
} from './interfaces';
import type { Filter } from '../../utils/listDaynamicFilter';
import Edit from './components/edit';

// apis
import { UploadBundlesRequestBuilder } from 'client-sdk/src/bundles/bundle';
import Client from 'client-sdk/src/client';
import handleNotfication from '../../utils/handleNotification';
import handleError from '../../utils/handleError';
import useQuery from '../../utils/hook/useQuery';
import RenderFilter from '../../utils/listDaynamicFilterHookFormMob';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    textArea: {
      width: '100%',
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    iconButton: {
      padding: 10,
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      top: '47px',
      right: 0,
      marginTop: '12px',
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'center',
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '12px 10px 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    titleBar: {
      zIndex: 10,
      position: 'fixed',
      top: '0px',
      right: '0px',
      display: 'flex',
      width: '85%',
      padding: '14px',
      boxShadow: 'none !important'
    },
  })
);

const Bundles: FunctionComponent<Props> = (props: Props) => {
  const token = localStorage.getItem('token') || '';
  const [filters, setFilters] = useState([] as Filter[]);
  const [openSize, setOpenSize] = React.useState(false as boolean);
  const { filtersValues, setFiltersValues } = useQuery({
    page: 0,
    size: 100,
  } as any,'');
  const [openConfirmCancel, setOpenConfirmCancel] = useState(false as boolean);
  const [openConfirmUpdateState, setOpenConfirmUpdateState] = useState(
    false as boolean
  );
  const [previewState, setPreviewState] = useState('CANCELLED' as Status);
  const [id, setId] = useState(-1 as number);
  const [cancelDescription, setCancelDescription] = useState('' as string);

  const [editModal, setEditModal] = useState(false as boolean);
  const [editId, setEditId] = useState(-1 as number);
  const [fileName, setFileName] = useState<any>('');
  const [uploadExelModal, setUploadExelModal] = useState(false as boolean);
  const [confirmModal, setConfirmModal] = useState(false as boolean);
  const [file, setFile] = useState<any>(null);
  const [loading, setLoading] = useState(false as boolean);
  const filterTranslator = (fieldName: string) => {
    const status = {
      customerName: 'نام سفارش دهنده',
      'customerName.equals': 'نام سفارش دهنده:',
      'customerName.contains': 'نام سفارش دهنده:',
      trackingCode: 'کد پیگیری',
      'trackingCode.equals': 'کد پیگیری',
      'trackingCode.contains': 'کد پیگیری',
      'id.equals': 'شناسه سفارش:',
      'id.contains': 'شناسه سفارش:',
      deliveryDate: 'زمان تحویل',
      'deliveryDate.equals': 'زمان تحویل:',
      'deliveryDate.contains': 'زمان تحویل:',
      status: 'وضعیت سفارش',
      'status.in': 'وضعیت سفارش:',
      'status.notIn': 'وضعیت سفارش:',
    };
    return status[fieldName];
  };
  const removeFilterHandler = (fieldName: any) => {
    const filtered = { ...filtersValues };
    delete filtered[fieldName];
    setFiltersValues(filtered);
  };
  const handleCloseEditModal = () => {
    setEditModal(false);
    if (editId > 0) {
      getBundles();
    }
    setEditId(-1);
  };

  useEffect(() => {
    getBundles();
    setupFilters();
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps
  const classes = useStyles();
  const handleChangePage = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
  };

  const getBundles = () => {
    const { page, size } = filtersValues;
    props.bundlesDispatch({
      ...removeEmptyValueObject(filtersValues),
      page,
      size,
    });
  };

  const setupFilters = () => {
    setFilters([
      {
        type: 'input',
        id: 'driverName.contains',
        label: 'نام راننده',
        icon: mdiAccountOutline,
      },
      {
        type: 'input',
        id: 'id.equals',
        label: 'شناسه مرسوله',
        icon: mdiPackageVariantClosed,
      },
      {
        type: 'input',
        id: 'ordersId.equals',
        label: 'شناسه سفارش',
        icon: mdiPackageVariant,
      },
      {
        type: 'input',
        id: 'orderTrackingCode.equals',
        label: 'کد رهگیری',
        icon: mdiKey,
      },
      {
        type: 'input',
        id: 'sourceName.equals',
        label: 'نام مرکز',
        icon: mdiHomeSearchOutline,
      },
      {
        type: 'checkbox',
        id: 'status.in',
        label: 'وضعیت مرسوله',
        data: [
          'CREATED',
          'ASSIGNED',
          'LOADED',
          'VEHICLE_ARRIVED',
          'PROCESSED',
          'PROCESS_STARTED',
          'PROCESS_FAILED',
          'CANCELLED',
        ],
        icon: mdiStateMachine,
      },
      {
        type: 'date-picker',
        id: 'deliveryDate.greaterThanOrEqual',
        label: 'تاریخ تحویل از ',
        icon: mdiCalendar,
      },
      {
        type: 'date-picker',
        id: 'deliveryDate.lessThanOrEqual',
        label: '  تا تاریخ تحویل ',
        icon: mdiCalendar,
      },
    ]);
  };
  let headCells = [];

  headCells = [
    {
      id: 'driverName',
      label: 'نام راننده',
      type: 'input',
    },
    { id: 'id', label: 'شناسه مرسوله', type: 'input' },
    { id: 'ordersCount', label: 'تعداد سفارش', type: 'input' },
    { id: 'sourceName', label: 'مرکز/انبار', type: 'input' },
    {
      id: 'deliveryDate',
      label: 'زمان تحویل',
      type: 'date-picker',
    },
    {
      id: 'status',
      label: 'وضعیت مرسوله',
      type: 'checkbox',
      data: [
        'CREATED',
        'ASSIGNED',
        'LOADED',
        'VEHICLE_ARRIVED',
        'PROCESSED',
        'PROCESS_STARTED',
        'PROCESS_FAILED',
        'CANCELLED',
      ],
    },
  ];
  const head = { headCells };
  const handleCancelBundle = async () => {
    await props.cancelbundleDispatch({
      id,
      body: { description: cancelDescription },
    });
    getBundles();
    setOpenConfirmCancel(false);
  };

  const handleOpenConfirmBox = (id: number) => {
    setOpenConfirmCancel(true);
    setId(id);
  };

  const handleClose = () => {
    setOpenConfirmCancel(false);
    setOpenConfirmUpdateState(false);
    setOpenSize(false);
  };
  const handleOpenConfirmUpdateState = (data: { id: number; body: Status }) => {
    setOpenConfirmUpdateState(true);
    setId(data.id);
    setPreviewState(data.body);
  };
  const changeStatusBundle = () => {
    props.updateBundleStatusDispatch({
      id,
      body: previewState,
      pagination: filtersValues,
    });
    setOpenConfirmUpdateState(false);
  };

  const findStatus = (id: number) => {
    const status = props.bundlesList.find(order => order.id === id)?.status;
    return status && translate(status, 'bundle');
  };

  const handleChangeSizePage = (event: React.ChangeEvent<{ value: unknown }>) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
  };

  const handleOpenEdit = (id: number) => {
    setEditModal(true);
    setEditId(id);
  };

  const handleCloseExelModal = () => {
    setUploadExelModal(false);
    setFileName('');
    setFile('');

  }
  const handleChangeFileInput = (event: any) => {
    setFileName(event.target.files[0].name);
    if (event.target.files[0]) {
      setFile(event.target.files[0]);
    }
  };

  const handleCloseConfirmModal = () => {
    setConfirmModal(false);
  };

  const handleOpenConfirmModal = () => {
    setConfirmModal(true);
  }

  const handleUploadBundles = async () => {
    try {
      setLoading(true);
      let payload = new FormData();
      payload.append('file', file);
      const makeRequest = new UploadBundlesRequestBuilder()
        .data(payload)
        .build();
      const client = new Client(token);
      await client.execute(makeRequest);
      handleNotfication('مرسوله ها با موفقیت ایجاد شدند', 'success');
    }
    catch (err) {
      if (err?.response.status === 406) {
        handleNotfication('فرمت فایل اپلود شده صحیح نمیباشد موارد را اصلاح کنید', 'error')
        return;
      }
      handleError(err.response);
    }
    finally {
      setLoading(false)
      handleCloseConfirmModal();
      handleCloseExelModal();
    }
  };

  return (
    <div>
      <Grid container spacing={2}>
      <Grid container>
          <Paper
            className={classes.titleBar}
          >
            <Grid container xs={10} justifyContent={'center'} alignContent={'center'}>
              <Typography variant="h6" component="h2">
                {'لیست محموله‌ها '}
              </Typography>

            </Grid>
            {/* <span >
              <Link to={'/mobile-home'}>
                <Icon path={mdiHomeOutline} size={1.2} color={'black'} />
              </Link>
            </span> */}
          </Paper>
        </Grid>
        <Grid item xs={12} sm={6}>
          <RenderFilter
            filters={filters}
            onFilter={(filtervalues: any) => {
              setFiltersValues({
                ...removeEmptyValueObject(filtervalues),
                page: 0,
                size: 100,
              });
            }}
            mainFiltersCount={0}
            baseFilter={{
              type: 'input',
              id: 'id.equals',
              placeholder: 'شناسه مرسوله',
            }}
            filterValues={filtersValues}
          />
        </Grid>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {props.loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            <>
              <List
                handleOpenEdit={handleOpenEdit}
                data={props.bundlesList}
                handleClickOpen={handleOpenConfirmBox}
                changeStatus={handleOpenConfirmUpdateState}
                head={head}
                filterVal={filtersValues}
                onFilterValue={(filtervalues: any) => {
                  setFiltersValues({
                    ...removeEmptyValueObject(filtervalues),
                    ...filtersValues,
                    page: 0,
                    size: 10,
                  });
                }}
                removeFilterHandler={removeFilterHandler}
                filterLabelTranslator={filterTranslator}
              />
            </>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
              {' '}
              تعداد نمایش در هر صفحه:
            </div>
            <Select
              open={openSize}
              onClose={handleClose}
              onOpen={() => setOpenSize(true)}
              value={filtersValues.size}
              onChange={handleChangeSizePage}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid xs={12} sm={6} container item direction="row-reverse">
          <Pagination
            className={classes.pagination}
            count={Math.ceil(props.count / filtersValues.size)}
            color="secondary"
            page={filtersValues.page + 1}
            onChange={handleChangePage}
          />
        </Grid>
      </Grid>
      <Dialog
        fullWidth
        open={openConfirmCancel}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            {handleClose ? (
              <IconButton
                aria-label="close"
                // className={classes.closeButton}
                onClick={handleClose}
              >
                <Icon path={mdiClose} size={1} />
              </IconButton>
            ) : null}
          </div>
          <div className={classes.cancelIcon}>
            <Icon path={mdiClose} size={4} color={theme.palette.error.main} />
          </div>
          <div
            className={classes.cancelTitle}
          >{`از لغو مرسوله با شناسه ${id} مطمئن هستید؟`}</div>
          <TextField
            className={classes.textArea}
            placeholder={`علت لغو...`}
            value={cancelDescription}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setCancelDescription(e.target.value)
            }
          />
        </DialogContent>

        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
                size="large"
              >
                {`خیر`}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                onClick={handleCancelBundle}
                variant="contained"
                size="large"
                disabled={!(cancelDescription.length > 0)}
              >
                {`بله`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openConfirmUpdateState}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle />
        <DialogContent>
          <div className={classes.editIcon}>
            <Icon
              path={mdiPencilOutline}
              size={4}
              color={theme.palette.blue.main}
            />
          </div>
          <div className={classes.cancelTitle}>
            {`از تغییر تگ وضعیت مرسوله
        "${id > -1 && findStatus(id)}"
        به
       " ${translate(previewState.replace(/"/g, '') as Status, 'bundle')}"
    
        
        مطمئن هستید؟`}
          </div>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleClose}
                variant="contained"
                color="secondary"
              >
                {`خیر`}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                onClick={changeStatusBundle}
                color="primary"
                variant="outlined"
              >
                {`بله`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        fullWidth
        open={uploadExelModal}
        onClose={handleCloseExelModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>ایجاد مرسوله با اکسل</DialogTitle>
        <DialogContent>
          <div className={classes.editIcon}>
            <Icon path={mdiFile} size={4} color={theme.palette.success.main} />
          </div>
          <div className={classes.cancelTitle}>
            <FormLabel style={{ fontSize: '14px', marginLeft: '10px' }}>
              بارگذاری فایل
            </FormLabel>
            <TextField
              id="amount"
              name="amount"
              variant="outlined"
              placeholder="نام فایل"
              className={classes.textInput}
              value={fileName}
              disabled
            />
            <IconButton component="label" title="آپلود فایل">
              <Icon
                color={theme.palette.secondary.main}
                path={mdiPaperclip}
                size={1}
              />
              <input
                type="file"
                name="file"
                onChange={handleChangeFileInput}
                onClick={(e: React.ChangeEvent<{ value: unknown }>) =>
                  (e.target.value = null)
                }
                hidden
              />
            </IconButton>
          </div>
        </DialogContent>
        <DialogActions>
          <Grid container spacing={1}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseExelModal}
                variant="contained"
                color="secondary"
              >
                {`بستن`}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                onClick={handleOpenConfirmModal}
                color="primary"
                disabled={!file}
                variant="outlined"
              >
                {`ایجاد مرسوله`}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      <Dialog
        open={confirmModal}
        fullWidth
        onClose={handleCloseConfirmModal}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogContent>
          <div
            style={{
              position: 'absolute',
              left: '17px',
              zIndex: 10,
            }}
          >
            <IconButton aria-label="close" onClick={handleCloseConfirmModal}>
              <Icon path={mdiClose} size={1} />
            </IconButton>
          </div>
          <div className={classes.cancelIcon}>
            <Icon path={mdiPlus} size={4} color={theme.palette.green.main} />
          </div>
          <div
            className={classes.cancelTitle}
          >{`آیا از ایجاد مرسوله از طریق فایل با نام ${fileName} مطمئن هستید؟`}</div>
        </DialogContent>
        <DialogActions className={classes.actionsBox}>
          <Grid container spacing={2}>
            <Grid item xs={8}>
              <Button
                fullWidth
                autoFocus
                onClick={handleCloseConfirmModal}
                variant="contained"
                color="secondary"
                size="large"
              >
                {'خیر'}
              </Button>
            </Grid>
            <Grid item xs={4}>
              <Button
                fullWidth
                variant="contained"
                onClick={handleUploadBundles}
                size="large"
                disabled={loading}
              >
                {'بله'}
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      {editId > 0 && (
        <Edit
          data={props?.bundlesList?.filter(el => el.id === +editId)?.[0]}
          handleCloseEditModal={handleCloseEditModal}
          show={editModal}
        />
      )}
    </div>
  );
};

export default Bundles;
